import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\src\\app\\liquor-bottle\\page.tsx");
